import Moment from 'moment'

export function CheckCorrectWrittenInput(val, dateFormat) {
    const [startDate, endDate] = val.split('-')

    if (!startDate || !endDate) {
        return false
    }

    return startDate.indexOf('_') === -1 && endDate.indexOf('_') === -1
}

export function CheckCorrectDates(val, dateFormat) {
    const [startDate, endDate] = val.split('-')

    if (!startDate || !endDate) {
        return false
    }

    return Moment(startDate, dateFormat).isValid() &&
        Moment(endDate, dateFormat).isValid()
}

export function CheckMinMaxDate(val, funcCheckDatesDisabled, dateFormat) {
    const [startDate, endDate] = val.split('-')

    return !funcCheckDatesDisabled(Moment(startDate, dateFormat)) &&
        !funcCheckDatesDisabled(Moment(endDate, dateFormat))
}

export function CheckDifferenceBetweenDate(val, dateFormat) {
    const [startDate, endDate] = val.split('-')

    return Moment(endDate, dateFormat).diff(Moment(startDate, dateFormat)) >= 0
}